import AttributeStore from './attributeStore';

class RentApartmentsAttributes extends AttributeStore {
  getAttributes () {
    return [
      {
        title: 'Характеристики ' + this.getCase(),
        items: [
          this.getRentPeriod(),
          this.getNewHouse(),
          this.getBuildingType(),
          this.getFloor(),
          this.getRenovation(),
          this.getPlaning(),
          this.getFurniture(),
          this.getFridge(),
          this.getTV(),
          this.getWashingMachine(),
          this.getConditioning(),
          this.getBalcony(),
          this.getGenderPreference(),
          this.getPersonCount(),
          this.getChildAllowed(),
          this.getAnimalAllowed()
        ].filter(Boolean)
      }
    ];
  }
}

export default RentApartmentsAttributes;



// WEBPACK FOOTER //
// ./src/classes/announcement/attributes/rentApartmentsAttributes.js